import React from "react";
import Home from "../pages/Home";
import Dashboard2 from "../pages/Dashboard2.0";
import Dashboard2_1 from "../pages/Dashboard2.1";
import WareHouseTimeLineViewContainer from "../pages/WareHouseTimeLine";
import AddWorker from "../pages/AddWorker";
import AddEditWorker from "../pages/AddEditWorker/AddEditWorkerContainer"
import Punch from "../pages/Punch";
import Review from "../pages/Review";
import { DSCPage } from "pages/DSC";
import { BulkUploadPage } from "pages/BulkUpload";
import { DSCEmployeeLevelPlanningPage } from "pages/DSCEmployeeLevelPlanning";
import { HighDurationAllPunchesView } from "pages/Review/components/HighDurationAllPunchesView";
import PunchFromSupervisor from "../pages/Review/components/AddEditPunch";
import SupervisorPTO from "../pages/Review/components/AddEditPTO";
import { AltRegistration, AltRegistrationSuccess } from "pages/Covid19";
import { DriverForm, DriverFormSuccess } from "pages/RouteUpdate";
import { IdeaForm, IdeaFormSuccess } from "pages/IdeaSubmission";
import { GlobalForm,GlobalFormSuccess } from "pages/GlobalSubmission";
import { SentinelCoachForm,SentinelCoachFormSuccess } from "pages/SentinelCoachSubmission";
import { TimeSheetPage } from "pages/Timesheet";
import ResetLastPunchId from "components/ResetLastPunchId";
import WarehouseProjectUpload from "pages/WarehouseProjectUpload";
import UndeleteWorker from "components/UndeleteWorker";
import ITContractorUpload from "pages/ITContractorUpload";
import { Switch, Route } from "react-router-dom";
import {
  ROOT,
  PUNCH,
  REVIEW,
  ADD_WORKER,
  ADD_EDIT_PUNCH_SUPERVISOR,
  SUPERVISOR_PTO,
  DSC,
  ADD_TIMESHEET,
  ADD_EDIT_ACTIVITY,
  ALL_HIGH_DURATION_ACTIVITIES,
  COVID_19,
  COVID_19_SUCCESS,
  DRIVER_FORM,
  DRIVER_FORM_SUCCESS,
  DASHBOARD_2,
  DASHBOARD_2_1,
  WARE_HOUSE_TIMELINE_VIEW,
  IDEA_FORM,
  IDEA_FORM_SUCCESS,
  GLOBAL_FORM,
  GLOBAL_FORM_SUCCESS,
  SENTINEL_COACH_FORM,
  SENTINEL_COACH_FORM_SUCCESS,
  REST_LAST_PUNCH_ID_VIEW,
  WAREHOUSE_PROJECT_UPLOAD,
  UNDELETE_WORKER,
  CONTRACTOR_TIMESHEET,
  CONTRACTOR_TIMESHEET_REPORT,
  ITCONTRACTOR_UPLOAD,
  DSC_EMPLOYEE_LEVEL_PLANING,
  VEHICLE_SUPPLIER_CHECKLIST_FORM_SUCCESS,
  VEHICLE_SUPPLIER_CHECKLIST_FORMS,  
} from "./CONSTANTS";
import PrivateRoute from "./PrivateRoute";
import NotFound from "./NotFound";
import { ManageActivityGroups } from "pages/Review/components/ManageActivityGroups";
import AddEditActivity from "pages/AddEditActivity/AddEditActivityContainer";
import { ContractorTimesheetPage } from "pages/ContractorTimesheet";
import ContractorTimesheetReport from "pages/Review/components/ContractorTimesheetReportView";
import VehicleChecklistForm from "pages/VehicleChecklistFormToggle/VehicleChecklistForm";
import VehicleCheckListFormSuccess from "pages/VehicleChecklistFormToggle/VehicleChecklistFormSuccess";

export const RouterConfig = () => {
  return (
    <Switch>
      <Route exact sensitive path={ROOT} component={Home} />
      <Route exact sensitive path={COVID_19} component={AltRegistration} />
      <Route exact sensitive path={"/timesheet"} component={TimeSheetPage} />
      <Route
        exact
        sensitive
        path={COVID_19_SUCCESS}
        component={AltRegistrationSuccess}
      />
      <Route exact sensitive path={DASHBOARD_2} component={Dashboard2} />

      <PrivateRoute sensitive path={DASHBOARD_2_1} isSupervisorRistricted={true}>
        <Dashboard2_1/>
      </PrivateRoute>

      <PrivateRoute sensitive path={WARE_HOUSE_TIMELINE_VIEW} isSupervisorRistricted={true}>
        <WareHouseTimeLineViewContainer />
      </PrivateRoute>
      
      <Route exact sensitive path={DRIVER_FORM} component={DriverForm} />
      <Route
        exact
        sensitive
        path={DRIVER_FORM_SUCCESS}
        component={DriverFormSuccess}
      />

      <Route exact sensitive path={IDEA_FORM} component={IdeaForm} />
      <Route
        exact
        sensitive
        path={IDEA_FORM_SUCCESS}
        component={IdeaFormSuccess}
      />

    <Route exact sensitive path={GLOBAL_FORM} component={GlobalForm} />
      <Route
        exact
        sensitive
        path={GLOBAL_FORM_SUCCESS}
        component={GlobalFormSuccess}
      />

    <Route exact sensitive path={SENTINEL_COACH_FORM} component={SentinelCoachForm} />
      <Route
        exact
        sensitive
        path={SENTINEL_COACH_FORM_SUCCESS}
        component={SentinelCoachFormSuccess}
      />

      <Route exact sensitive path={VEHICLE_SUPPLIER_CHECKLIST_FORMS} component={VehicleChecklistForm} />
      <Route
        exact
        sensitive
        path={VEHICLE_SUPPLIER_CHECKLIST_FORM_SUCCESS}
        component={VehicleCheckListFormSuccess}
      />

      <PrivateRoute sensitive path={REST_LAST_PUNCH_ID_VIEW} isSupervisorRistricted={true}>
        <ResetLastPunchId />
      </PrivateRoute>

      <PrivateRoute sensitive path={UNDELETE_WORKER} isSupervisorRistricted={true}>
        <UndeleteWorker />
      </PrivateRoute>
      
      <Route
        exact
        sensitive
        path={WAREHOUSE_PROJECT_UPLOAD}
        component={WarehouseProjectUpload}
      />

      <Route
        exact
        sensitive
        path={ITCONTRACTOR_UPLOAD}
        component={ITContractorUpload}
      />
      <PrivateRoute sensitive path={DSC} isSupervisorRistricted={true}>
        <DSCPage />
      </PrivateRoute>
      <PrivateRoute sensitive path={DSC_EMPLOYEE_LEVEL_PLANING} isSupervisorRistricted={true}>
        <DSCEmployeeLevelPlanningPage />
      </PrivateRoute>
      dscEmployeeLevrlPlaningTitle

      <PrivateRoute
        sensitive
        path={ADD_TIMESHEET}
        isSupervisorRistricted={true}
      >
        <BulkUploadPage />
      </PrivateRoute>
      {/* <PrivateRoute path={ALL_HIGH_DURATION_ACTIVITIES} isSupervisorRistricted={true}>
        <HighDurationAllPunchesView />
      </PrivateRoute> */}
      <Route exact sensitive path={PUNCH} component={Punch} />
      {/* <Route exact sensitive path={ADD_WORKER} component={AddEditWorker} />
      <Route exact sensitive path={ADD_EDIT_WORKER} component={AddEditWorker}/> */}
      <PrivateRoute sensitive path={ADD_WORKER} isSupervisorRistricted={true}>
        <AddEditWorker/>
      </PrivateRoute>
      <Route
        exact
        sensitive
        path={ADD_EDIT_PUNCH_SUPERVISOR}
        component={PunchFromSupervisor}
      />
      <Route exact sensitive path={SUPERVISOR_PTO} component={SupervisorPTO} />
      <Route
        exact
        sensitive
        path={ADD_EDIT_ACTIVITY}
        component={AddEditActivity}
      />
      {/* Use below links for UI development */}
      {/* <Route exact path={WORKER} component={Worker} />
      <Route exact path={REVIEW} component={Review} /> */}

      {/* All the authentication protected routes will go here */}

      <Route exact sensitive path ={CONTRACTOR_TIMESHEET_REPORT} component={ContractorTimesheetReport}/>
      <PrivateRoute sensitive path={REVIEW} isSupervisorRistricted={true}>
        <Review />
      </PrivateRoute>

      <Route sensitive path={CONTRACTOR_TIMESHEET} isSupervisorRistricted={true}>
        <ContractorTimesheetPage />
      </Route>

      {/* 404 page not found will redirect to Home screen */}
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
};

export default RouterConfig;
